import React from 'react';
import AdminDashboardComponent from '../components/admin/dashboard/AdminDashboard';

const AdminDashboard = () => {
    return (
        <AdminDashboardComponent />
    );
};

export default AdminDashboard;